import { useState } from 'react'
import { type ProductSearchInputProps } from '../components/DialogChangeButlerItem/ProductSearchInput'

export const useButlerSearchInput = () => {
  const [inputValue, setInputValue] = useState('')
  const [query, setQuery] = useState('')

  const handleInputChange: ProductSearchInputProps['onChange'] = (e) => {
    setInputValue(e.target.value)
    if (e.target.value === '') {
      setQuery('')
    }
  }

  const handleClearInputValue = () => {
    setInputValue('')
    setQuery('')
  }

  const handleSearchSubmit: ProductSearchInputProps['onSubmit'] = (value) => {
    setQuery(value)
  }

  const handleHistoryClick = (item: string) => {
    setQuery(item)
    setInputValue(item)
  }

  return {
    query,
    inputValue,
    handleClearInputValue,
    handleInputChange,
    handleSearchSubmit,
    handleHistoryClick,
  }
}
